<template>
    <div class="container-fluid bg-schedule m-0 p-0 animated fadeIn slow" style="height: 100vh;">
        <div class="lime-bar-footer fixed-bottom"></div>
        <div v-if="userAccount">
            <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'" class="container px-0"
                 style="position: relative;">
                <TheHeader/>
                <div class="d-flex flex-column content-wrapper">
                    <div class="align-self-center my-auto">
                        <div class="mt-0 mt-md-5 pt-5">
                            <div class="title font-italic font-weight-bold text-uppercase">
                                your attendance is necessary
                            </div>
                            <div class="lime-bar-diag">
                                <img src="../assets/img/Asset_3.png" alt="" class="">
                            </div>
                            <div class="text-uppercase font-italic sub-title font-sm">
                                time to diversify.
                            </div>
                        </div>

                        <div class="d-flex justify-content-center">
                            <div class="font-italic mt-5 text-left">
                                <p>The RUFUS Schedule is designed for racers who are racers. It's built from the
                                    principles that made Mario, AJ, Jim, Jackie, and Dan legendary icons on an entirely
                                    different level, as a platform for today's best to chase that kind of recognition
                                    and respect. It's made up of motorsport's grandest stages mixed with events defined
                                    by unique challenges and intense native competition from all across global
                                    motorsport. From local dirt tracks to the Monaco Grand Prix, RUFUS IS racing, and
                                    its Schedule is a key ingredient.</p>

                                <p>Each F1, IndyCar, and NASCAR driver starts with three races built into their home
                                    schedule. <strong>We count a driver’s seven best results</strong>. A driver can do
                                    more than seven events to drop poor results, but seven is the magic number. As such,
                                    F1, IndyCar, and NASCAR drivers must find four events outside their normal specialty
                                    to get there.</p>

                                <p>As you'll see below, some scoring opportunities are in the form of "<span
                                        class="text-pink">hard events</span>" on the calendar - specific races on
                                    specific dates - while other scoring opportunities are in the form of "<span
                                            class="text-lime">flexible events</span>" within a championship. In the case
                                    of hard events, a driver must compete in that specific race in order to score
                                    points, and his or her result from that race is firm. In the case of flexible
                                    events, we count a driver's result from any single or remaining event in a given
                                    championship to increase the number of events a driver can choose from. If a driver
                                    competes in more than one flexible event within a championship we still only tally
                                    one result, but we'll take their best finish.</p>

                                <div class="font-italic text-left my-5">
                                    <div class="font-xl">
                                        <strong>The Schedule: </strong></div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex legend">
                            <div class="ml-auto">
                                <div class="text-left">
                                    <div class="row">
                                        <div class="col">
                                            <div class="d-flex text-left">
                                                <div class="dot-red shadow-sm mr-2"></div>
                                                <div class="font-italic">hard events</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="d-flex">
                                                <div class="dot-lime shadow-sm mr-2"></div>
                                                <div class="font-italic">flexible events</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-center mt-2 px-2">
                            <div>
                                <div class="row">
                                    <div class="col-1"></div>
                                    <div class="col-11 p-0 pl-1 text-left"><strong>Major Circuit Racing
                                        Championships: </strong></div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                        <div class="dot-red shadow-sm"></div>
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">F1: Monaco Grand Prix, Belgian Grand Prix,
                                        best
                                        additional result
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                        <div class="dot-red shadow-sm"></div>
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">IndyCar: Long Beach Grand Prix, Indianapolis
                                        500,
                                        best additional result
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                        <div class="dot-red shadow-sm"></div>
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">NASCAR: Daytona 500, Bristol Night Race, best
                                        additional result
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">WEC: 24hrs of Le Mans, best additional result
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">IMSA: 24hrs of Daytona, best additional
                                        result
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-1"></div>
                                    <div class="col-11 p-0 pl-1 text-left"><strong>Road Course Racing: </strong></div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">12hrs of Bathurst
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">24hrs of Nürburgring
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Supercars: best single result, any race
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Super GT: best single result, any race
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">DTM: best single result, any race
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Formula E: best single result, any race
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">International FIACIK Karting Championship (OK
                                        or
                                        KZ): best single result, any event
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-1"></div>
                                    <div class="col-11 p-0 pl-1 text-left"><strong>Dirt/Circle Track: </strong></div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Chili Bowl
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Dirt Late Model Event TBD
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Snowball Derby
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">USAC Midgets: best single feature result, any
                                        race
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">WoO: best single feature result, any race
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-1"></div>
                                    <div class="col-11 p-0 pl-1 text-left"><strong>Rally, Desert, Offroad: </strong>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Dakar Rally
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Arctic Rally
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Nitro World Games Rally
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Pikes Peak International Hillclimb
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-red shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Baja 1000
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">WRC: best single result, any event
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">ERC: best single result, any event
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">World RallyX: best single result, any event
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-2 col-md-1 ml--4 text-right p-0 d-flex justify-content-end pr-1">
                                        <div class="dot-lime shadow-sm"></div>
                                    </div>
                                    <div class="col-10 col-md-11 p-0 pl-1 text-left">Andros Trophy: best single result, any race
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-center mt-5">
                            <div class="font-italic text-left">
                                <div class="font-xl"><strong>Pick Seven.</strong></div>

                                <p class="mt-3">This schedule is designed to produce highly RUFUS outcomes. We recognize
                                    that doing seven events on this schedule will be difficult, that is with purpose to
                                    require diversification. While the exact events on this schedule may change over
                                    time, consider this a model to build around going forward.</p>

                                <p class="mt-3">(We compiled a data set of more than 10,000 historical event records by
                                    year, driver, and
                                    category to test various scoring systems, scheduling criteria and more. This formula
                                    produced the most retrospectively RUFUS results.)</p>
                            </div>

                        </div>
                        <div class="d-flex mb-5">
                            <div class="font-italic text-left mb-5">
                                <div class="font-xl mt-4"><strong>Champion’s Rules:
                                </strong></div>

                                <p class="mt-3">A driver <strong>must compete in seven events</strong> to be crowned
                                    champion.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="font-xl font-weight-semi-bold">
                <div class="container mb-5 pb-5">
                    <TheHeader/>
                </div>
                <div style="margin-top: 200px;">
                    Sorry, you don't have the correct permissions to access this
                    page...
                </div>
            </div>
        </div>

        <div v-else class="font-xl font-weight-semi-bold container" style="margin-top: 200px;">Sorry, you don't have the
            correct permissions to access this
            page...
        </div>
    </div>

</template>

<script>
    // @ is an alias to /src
    // import firebase from 'firebase'
    import TheHeader from '../components/TheHeader';


    export default {
        name      : 'schedule',
        components: {
            TheHeader
        },
        data () {
            return {
                // authorizedUsers: ['3zMvfjvdItVANPI32rR0LIv9GDW2', '3967Hnn8hAY3yi2bYzDnNSovVgc2'],
                // admin          : false
            }
        },
        computed  : {
            userAccount () {
                return this.$store.getters.getUserAccount;
            },
            userRole () {
                return this.$store.getters.getUserRole
            }
        },
        watch     : {
            userRole (val) {
                if (val === 'admin' || val === 'driver' || val === 'industry') {
                    // console.log('admin or driver...');
                    this.$router.push({name: 'schedule'})
                } else {
                    // console.log('not admin or driver');
                    this.$router.push({name: 'login'})
                }
            }
        },
        created () {
            this.$store.dispatch('getUserAccount')
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/css/_vars.scss';

    .dot-red {
        height: 10px;
        width: 10px;
        min-height: 10px;
        min-width: 10px;
        background-color: #ff007f;
        border-radius: 50%;
        -webkit-transform: translateY(6.5px);
        -moz-transform: translateY(6.5px);
        -ms-transform: translateY(6.5px);
        -o-transform: translateY(6.5px);
        transform: translateY(6.5px);
        margin-left: 2px;

    }

    .dot-lime {
        height: 10px;
        width: 10px;
        min-height: 10px;
        min-width: 10px;
        background-color: $lime;
        border-radius: 50%;
        -webkit-transform: translateY(6.5px);
        -moz-transform: translateY(6.5px);
        -ms-transform: translateY(6.5px);
        -o-transform: translateY(6.5px);
        transform: translateY(6.5px);
        margin-left: 2px;

    }

    .text-link {
        color: #666666 !important;
        letter-spacing: 3px;
        margin-left: 180px;
        text-decoration: none;
    }

    .bg-schedule {
        background-image: url(../assets/img/schedule.png);
        background-position: center; /* Center the image */
        background-repeat: no-repeat; /* Do not repeat the image */
        background-size: cover; /* Resize the background image to cover the entire container */
        background-attachment: fixed;
        overflow-x: auto;
    }

    .legend {
        /*margin-top: -48px;
        margin-bottom: 48px;*/
    }

    .text-lime, .text-pink {
        text-shadow: 0px 0px 5px #000000;
    }

    @media all and (max-width: 576px) {
        .content-wrapper {
            padding-left: 15px;
            padding-right: 15px;
        }

        .title {
            margin-left: -20px;
        }

        .sub-title {
            margin-left: 170px;
        }
    }

    @media all and (min-width: 577px) and (max-width: 767px) {

        .title {
            margin-left: -50px;
        }

        .sub-title {
            margin-left: 210px;
        }
    }

    @media all and (min-width: 768px) and (max-width: 991px) {

        .title {
            margin-left: -70px;
        }

        .sub-title {
            margin-left: 230px;
        }

    }

    @media all and (min-width: 992px) and (max-width: 1199px) {

        .title {
            margin-left: -90px;
        }

        .sub-title {
            margin-left: 230px;
        }

    }

    @media all and (min-width: 1200px) {

        .title {
            margin-left: -44px;
        }

        .sub-title {
            margin-left: 190px;
        }

    }


</style>
